module.exports = __webpack_public_path__ + "img/guitar-869217_1920.20a656f6.png";